import React from 'react'

import { AuthContextProvider, useAuthProvider } from '../hooks'

export const AuthProvider = ({ children }) => {
  const context = useAuthProvider()
  return <AuthContextProvider value={context}>{children}</AuthContextProvider>
}

export default AuthProvider
